<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="usage">
    <h1 class="font-weight-thin display-1 grey--text ml-3 mt-3 hidden-xs-only">
      Groupmail Account Usage
    </h1>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm8 md6>
          <v-card class="flexcard rounded-card elevation-0" height="100%">
            <v-card-title primary class="title">
              <span class="primary--text text-lighten-2">
                Usage Summary
              </span>
            </v-card-title>
            <v-card-text class="grow">
              <v-list two-line subheader>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="blue-grey--text"
                      >Account type:
                      <span class="title">{{
                        existingPlan
                      }}</span></v-list-tile-title
                    >
                    <v-list-tile-sub-title
                      >&nbsp;&nbsp;Status:
                      {{ planStatus }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="blue-grey--text"
                      >Daily Email Limit:
                      <span class="title">{{
                        account ? fmc(account.dayEmailLimit) : '?'
                      }}</span></v-list-tile-title
                    >
                    <v-list-tile-sub-title
                      >&nbsp;&nbsp;Monthly:
                      <span class="subheading"
                        >{{ account ? fmc(account.monthEmailLimit) : '?' }}
                      </span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content
                    v-if="account && !account.cancellation_effective_date"
                  >
                    <v-list-tile-sub-title class="blue-grey--text"
                      >Limits reset:
                      <span class="subheading">{{
                        account ? shortDate(account.dueDate) : '?'
                      }}</span></v-list-tile-sub-title
                    >
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-btn to="/billing" color="accent" round depressed
                      >{{ isTrial ? 'Upgrade' : 'Change' }}
                    </v-btn>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 sm4 md3>
          <v-card class="rounded-card elevation-0" height="100%">
            <v-card-title primary class="title">
              <span class="primary--text text-lighten-2">
                Today's usage
              </span>
            </v-card-title>
            <v-card-text class="text-xs-right">
              <span class="primary--text subheading font-weight-thin"
                >Email<br /></span
              ><span class="display-2 primary--text"
                ><count-to
                  :startVal="0"
                  :endVal="account ? account.dayEmail : 0"
                  :duration="5000"
                ></count-to></span
              ><span
                class="primary--text text--lighten-3 font-weight-thin display-1"
                >/{{ account ? fmc(account.dayEmailLimit) : '?' }}</span
              >
              <v-progress-linear
                color="success"
                height="6"
                v-model="dayEmailPercentage"
              ></v-progress-linear>
              <v-divider class="my-4"></v-divider>
              <span class="primary--text subheading font-weight-thin"
                >Events<br /></span
              ><span class="display-2 primary--text"
                ><count-to
                  :startVal="0"
                  :endVal="account ? account.dayMessage : 0"
                  :duration="5000"
                ></count-to
              ></span>
              <!--              <span-->
              <!--                class="primary&#45;&#45;text text&#45;&#45;lighten-3 font-weight-thin display-1"-->
              <!--                >/{{ account ? fmc(account.dayMessageLimit) : '?' }}</span-->
              <!--              >-->
              <!--              <v-progress-linear-->
              <!--                height="6"-->
              <!--                v-model="dayMessagePercentage"-->
              <!--              ></v-progress-linear>-->
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs6 sm4 md3>
          <v-card class="rounded-card elevation-0" height="100%">
            <v-card-title primary class="title">
              <span class="primary--text text-lighten-2">
                Current Month
              </span>
            </v-card-title>
            <v-card-text class="text-xs-right">
              <span class="primary--text subheading font-weight-thin"
                >Email<br /></span
              ><span class="display-2 primary--text"
                ><count-to
                  :startVal="0"
                  :endVal="account ? account.monthEmail : 0"
                  :duration="5000"
                ></count-to></span
              ><span
                class="primary--text text--lighten-3 font-weight-thin display-1"
                >/{{ account ? fmc(account.monthEmailLimit) : '?' }}</span
              >
              <v-progress-linear
                color="info"
                height="6"
                v-model="emailPercentage"
              ></v-progress-linear>
              <v-divider class="my-4"></v-divider>
              <span class="primary--text subheading font-weight-thin"
                >Events<br /></span
              ><span class="display-2 primary--text"
                ><count-to
                  :startVal="0"
                  :endVal="account ? account.monthMessage : 0"
                  :duration="5000"
                ></count-to
              ></span>
              <!--              <span-->
              <!--                class="primary&#45;&#45;text text&#45;&#45;lighten-3 font-weight-thin display-1"-->
              <!--                >/{{ account ? fmc(account.monthMessageLimit) : '?' }}</span-->
              <!--              >-->
              <!--              <v-progress-linear-->
              <!--                height="6"-->
              <!--                v-model="messagePercentage"-->
              <!--              ></v-progress-linear>-->
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm8 md12>
          <v-card class="rounded-card elevation-0" height="100%">
            <v-card-title primary class="title">
              <span class="primary--text text-lighten-2">
                Recent Usage
              </span>
            </v-card-title>
            <v-card-text>
              <v-tabs fixed-tabs v-model="tabs" v-if="hasMonthData()">
                <v-tab key="daily">
                  Daily
                </v-tab>
                <v-tab key="monthly">
                  Monthly
                </v-tab>
              </v-tabs>
              <div v-if="tabs === 0 || tabs === null || tabs === '0'">
                <lineChart
                  :chartData="usageData"
                  :options="usageOptions"
                ></lineChart>
              </div>
              <div v-else>
                <lineChart
                  :chartData="usageDataMonthly"
                  :options="usageOptions"
                ></lineChart>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import numeral from 'numeral';
import countTo from 'vue-count-to';
// import format from 'date-fns/format';
// import { subDays, endOfDay, parseISO } from 'date-fns';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import lineChart from '@/components/charts/lineChart';
import { mapState, mapGetters } from 'vuex';
dayjs.extend(utc);
dayjs.extend(LocalizedFormat);

export default {
  name: 'Account',
  components: { lineChart, countTo },
  data: () => ({
    menu: false,
    isAnnual: false,
    tabs: null,
    pieOptions: {
      legend: {
        display: true,
        position: 'bottom'
      },
      responsive: true,
      maintainAspectRatio: false
    },
    usageOptions: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ]
      },
      legend: {
        display: true,
        position: 'bottom'
      },
      // title: {
      //   display: true,
      //   text: 'Recent Daily Usage'
      // },
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  computed: {
    ...mapState('auth', ['account', 'user', 'team']),
    ...mapGetters('auth', ['isTeamOwner']),
    isTrial() {
      if (this.account) {
        return (
          this.account.status === 'TRIAL' || this.account.status === 'FREE'
        );
      }
      return true;
    },
    existingPlan() {
      // plans current are: Trial, Starter, Business, Marketer, Enterprise & Unlimited
      if (this.account) {
        return this.account.type || 'Free';
      }
      return 'Free';
    },
    planStatus() {
      if (this.account) {
        if (this.account.status === 'TRIAL') {
          return `${this.account.status}, expires on ${this.shortDate(
            this.account.expires
          )}`;
        } else if (this.account.status === 'ACTIVE') {
          if (this.account.cancellation_effective_date) {
            return `Cancelled, account active until ${this.shortDate(
              this.account.cancellation_effective_date
            )}`;
          }
          return `${this.account.status}, next billing date: ${this.shortDate(
            this.account.next_bill_date
          )}`;
        }
        return this.account.status;
      }
      return '';
    },
    emailPercentage() {
      if (this.account) {
        return (this.account.monthEmail / this.account.monthEmailLimit) * 100;
      }
      return 0;
    },
    messagePercentage() {
      if (this.account) {
        return (
          (this.account.monthMessage / this.account.monthMessageLimit) * 100
        );
      }
      return 0;
    },
    dayEmailPercentage() {
      if (this.account) {
        return (this.account.dayEmail / this.account.dayEmailLimit) * 100;
      }
      return 0;
    },
    dayMessagePercentage() {
      if (this.account) {
        return (this.account.dayMessage / this.account.dayMessageLimit) * 100;
      }
      return 0;
    },
    usageData() {
      let messageData = [];
      let labels = [];
      let emailData = [];
      if (this.account) {
        let workData;
        const dayData = this.account.daily;
        // old way: subDays(endOfDay(new Date()), 1).toISOString(); //today
        let firstDate = dayjs
          .utc()
          .endOf('day')
          .subtract(1, 'day')
          .format();
        // let firstDate = subHours(endOfDay(new Date().toISOString()), 24); //today
        if (dayData.length) {
          // firstDate = subDays(parseISO(dayData[0].d), 1).toISOString(); // first day in array
          firstDate = dayjs
            .utc(dayData[0].d)
            .subtract(1, 'day')
            .format();
        }
        if (dayData.length > 30) {
          dayData.splice(0, dayData.length - 30);
        }
        if (dayData.length < 15) {
          const x = 15 - dayData.length;
          const filler = Array.from(Array(x), (i, index) => {
            return {
              e: 0,
              m: 0,
              //d: subDays(parseISO(firstDate), x - index).toISOString()
              d: dayjs
                .utc(firstDate)
                .subtract(x - index, 'day')
                .format()
            };
          });
          workData = [...filler, ...dayData];
        } else {
          workData = [...dayData];
        }
        // console.log('working data:', workData);
        // const labels = workData.map(day => format(parseISO(day.d), 'd LLL'));
        labels = workData.map(day => dayjs.utc(day.d).format('ll'));
        emailData = workData.map(day => day.e);
        // console.log('emailData', emailData);
        messageData = workData.map(day => day.m);
      }
      return {
        labels: labels,
        title: 'Recent Daily Usage',
        datasets: [
          {
            label: 'Emails',
            borderColor: '#4CAF50',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#4CAF50',
            backgroundColor: 'transparent',
            data: emailData
          },
          {
            label: 'Events',
            borderColor: '#2196F3',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#2196F3',
            backgroundColor: 'transparent',
            data: messageData
          }
        ]
      };
    },
    usageDataMonthly() {
      let labels = [];
      let emailData = [];
      let messageData = [];
      if (this.account) {
        const monthData = this.account.monthly;

        if (monthData.length > 12) {
          monthData.splice(0, monthData.length - 12);
        }
        labels = monthData.map(month => dayjs.utc(month.d).format('LL'));
        emailData = monthData.map(month => month.e);
        messageData = monthData.map(month => month.m);
      }
      return {
        labels: labels,
        datasets: [
          {
            label: 'Emails',
            borderColor: '#4CAF50',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#4CAF50',
            backgroundColor: 'transparent',
            data: emailData
          },
          {
            label: 'Events',
            borderColor: '#2196F3',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#2196F3',
            backgroundColor: 'transparent',
            data: messageData
          }
        ]
      };
    }
  },
  mounted: async function() {
    await this.$store.dispatch('auth/getAccount');
  },
  methods: {
    fmc(numberString) {
      return numeral(numberString).format('0,0');
    },
    shortDate(dateString) {
      return dayjs.utc(dateString).format('ll');
    },
    hasMonthData() {
      return (
        this.account && this.account.monthly && this.account.monthly.length
      );
    }
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
.flexcard {
  display: flex;
  flex-direction: column;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
</style>
